import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { GoogleAnalytics } from '@grandvisionhq/analytics';
import { Context } from '@grandvisionhq/carts-v2';
import { Util } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { usePaymentsUIContext, PaymentFlow } from '@grandvisionhq/payments';
import { useIntl } from '@grandvisionhq/state';
import '@grandvisionhq/graphql';
import '@grandvisionhq/utils';
import '@grandvisionhq/api-client';
import '../../StepShipping/selectors.js';
import '@grandvisionhq/auth';
import '../../context/CheckoutSettings/context.js';
import '../../selectors.js';
import '@grandvisionhq/lib-utils-cart';
import { CreateOrderErrors } from '../../mappers/errors-mapping.js';
import '../../operations/mutations/set-customer-details.js';
import '../../operations/mutations/set-shipping-method.js';
import '../../operations/mutations/set-shipping-state.js';
import '../../operations/mutations/set-store.js';
import '../../operations/mutations/create-apple-pay-session.js';
import '../../operations/mutations/recreate-ordered-checkout.js';
import { mapConsentsToOrderModel } from '../../utils/map-consent-to-order-model.js';
import '../../utils/get-customer-details-payload.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';
import { useCreateOrder } from '../../hooks/orders/use-create-order.js';
import { mapPaymentDetailsForOrder } from '../../mappers/data/payment-details-mapper.js';
import { useRedirectToOrderComplete } from '../../hooks/orders/use-redirect-to-order-confirm-page.js';
import '../../operations/fragments/checkout-mutation-result.js';
import '../../operations/fragments/cart-mutation-failures.js';
import '../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../operations/fragments/paypal-payment.js';
import '../../operations/fragments/saved-user-details.js';
import '../../operations/queries/get-checkout-state.js';
import '../../operations/queries/get-user-details.js';

const useHandleOrderCreation = ()=>{
    const { cart  } = Context.useCart();
    const { href: returnPath  } = useLink({
        route: 'express.checkout.login',
        params: {
            cartId: '',
            cartHash: ''
        }
    }) || {};
    const intl = useIntl();
    const { isQrCodeModalOpen  } = usePaymentsUIContext();
    const prevIsQrCodeModalOpenValue = Util.usePrevious(isQrCodeModalOpen);
    const [createOrder, { orderResponse , paymentFlow , setPaymentFlow  }] = useCreateOrder({
        returnPath
    });
    React.useEffect(()=>{
        /**
     *  Reset Payment flow when cartId changes, when QrCodeModal is being closed
     */ if (prevIsQrCodeModalOpenValue !== isQrCodeModalOpen) {
            if ((cart === null || cart === void 0 ? void 0 : cart.id) && !isQrCodeModalOpen) {
                setPaymentFlow(PaymentFlow.UNDEFINED);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        isQrCodeModalOpen,
        prevIsQrCodeModalOpenValue
    ]);
    const redirectToOrderComplete = useRedirectToOrderComplete();
    const handlePlaceOrder = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*({ selectedPaymentMethod , selfUrl , consents , paymentDetails , donationInfo , isSaveDetailsInAccount =false , setIsOrderInProgress  }) {
            if (!cart || !cart.id || !selectedPaymentMethod) {
                console.error('No Cart');
                throw CreateOrderErrors.ORDER_CREATION_CALL_FAILED;
            }
            const analyticsId = yield GoogleAnalytics.getAnalyticsId().then((id)=>id
            );
            const mappedConsents = consents && mapConsentsToOrderModel(consents);
            const orderDraft = mapPaymentDetailsForOrder({
                intl,
                cartId: cart.id,
                totalPrice: cart.prices.totalPrice,
                returnUrl: `${selfUrl}/api/payment-callback?type=${selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type}&checkoutType=logged-in-regular`,
                paymentDetails,
                selectedPaymentMethod
            });
            const placeOrderInput = swcHelpers.objectSpread({}, orderDraft, analyticsId ? {
                analyticsId
            } : null, mappedConsents ? {
                consents: mappedConsents
            } : null, donationInfo && donationInfo.amount ? {
                donationIntent: {
                    amount: {
                        centAmount: donationInfo.amount,
                        currencyCode: intl.currency
                    },
                    foundationKey: donationInfo.key
                }
            } : null, {
                shouldCreateAccount: false,
                overwritePersonalDetails: isSaveDetailsInAccount
            });
            const createOrderResult = yield createOrder(placeOrderInput);
            if (createOrderResult && createOrderResult.success && !createOrderResult.redirect && createOrderResult.resultType !== 'QRCODE') {
                try {
                    redirectToOrderComplete({
                        cartId: createOrderResult === null || createOrderResult === void 0 ? void 0 : createOrderResult.cartId,
                        orderData: createOrderResult === null || createOrderResult === void 0 ? void 0 : createOrderResult.orderDataToken
                    });
                } catch (error) {
                    console.error(error);
                    setIsOrderInProgress(false);
                }
            } else {
                setIsOrderInProgress(false);
            }
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        createOrder,
        intl,
        redirectToOrderComplete
    ]);
    return {
        orderResponse,
        paymentFlow,
        handlePlaceOrder
    };
};

export { useHandleOrderCreation };
//# sourceMappingURL=useHandlerOrderCreation.js.map
